import { Route, Navigate } from 'react-router-dom';

export function RedirectRoutes() {
  return (
    <>
      {/* Legacy URL redirects */}
      <Route path="/login" element={<Navigate to="/auth" replace />} />
      <Route path="/register" element={<Navigate to="/auth/individual" replace />} />
      <Route path="/signup" element={<Navigate to="/auth/individual" replace />} />
      <Route path="/signin" element={<Navigate to="/auth" replace />} />
      
      {/* Old formation URLs */}
      <Route path="/training/:id" element={<Navigate to="/formation/:id" replace />} />
      <Route path="/trainings" element={<Navigate to="/formations" replace />} />
      
      {/* Old dashboard URLs */}
      <Route path="/account" element={<Navigate to="/profile" replace />} />
      <Route path="/settings" element={<Navigate to="/profile" replace />} />
      
      {/* Old inscription URLs */}
      <Route path="/inscription-tunnel/:courseId" element={<Navigate to="/inscription/:courseId" replace />} />
      
      {/* Old legal URLs */}
      <Route path="/legal" element={<Navigate to="/mentions-legales" replace />} />
      <Route path="/privacy" element={<Navigate to="/politique-confidentialite" replace />} />
      <Route path="/terms" element={<Navigate to="/cgv" replace />} />
    </>
  );
}
